import { s3Bucket } from 'util/env';
import { calculateAspectRatio } from 'logic/math';
import { DeviceConfig, ServiceMessageSet, ServiceMessageType, ThemeId } from 'shared/models';
import { getOverrideServiceMessageMediaUrl, getServiceMessageMediaUrl } from 'util/getMediaUrl';
import './ServiceMessageOverridePreview.css';

export type Props = {
    themeId: ThemeId | null;
    pixelWidth: number | null;
    pixelHeight: number | null;
    deviceConfig: DeviceConfig;
    serviceMessageSet: ServiceMessageSet | null;
    previewServiceMessageType: ServiceMessageType | null;
    themePreviewUrlFormatter?(themeId: ThemeId | null): string; // Allow Storybook to override the URL format
};

//
// Default to using an S3 URL
//
function defaultThemePreviewUrlFormatter(themeId: ThemeId | null): string {
    if (!s3Bucket || !themeId) return '';
    return `https://${s3Bucket}.s3.amazonaws.com/content/${themeId}/theme.png`;
}

export const ServiceMessageOverridePreview = ({ themeId, pixelWidth, pixelHeight, deviceConfig, serviceMessageSet, previewServiceMessageType, ...otherProps }: Props) => {
    const { themePreviewUrlFormatter = defaultThemePreviewUrlFormatter } = otherProps;
    const { aspectWidth, aspectHeight } = calculateAspectRatio(pixelWidth, pixelHeight);
    const defaultFiles = (previewServiceMessageType && serviceMessageSet && serviceMessageSet.messages[previewServiceMessageType]) || null;
    const overrideFiles = (previewServiceMessageType && deviceConfig.properties.serviceMessageOverrides[previewServiceMessageType]) || null;
    const files = overrideFiles || defaultFiles || {};

    const getMediaUrl = (filename: string) =>
        overrideFiles
            ? getOverrideServiceMessageMediaUrl(deviceConfig.id, filename)
            : getServiceMessageMediaUrl(serviceMessageSet!.id, filename);

    // Note: we're ignoring audio overrides for now.

    return (
        <div className="service-message-override-preview" style={ {
            aspectRatio: `${aspectWidth} / ${aspectHeight}`,
            background: `center/contain url('${themePreviewUrlFormatter(themeId)}') no-repeat`,
        } }>
            { files.videoFileName &&
                <video
                    controls={ false }
                    autoPlay={ true }
                    loop={ true }
                    src={ getMediaUrl(files.videoFileName) }
                />
            }
            { files.imageFileName &&
                <img
                    alt=""
                    src={ getMediaUrl(files.imageFileName) }
                />
            }
        </div>
    );
};
